export function assertDefinedOrReportProblem <T>(data: T, description?: string): asserts data is NonNullable<T> {
  if (data === null || data === undefined) {
    console.error(`Value is not defined`, description || '');
  }
}
